let isMegaMenuHoverBound = false;
let isMegaMenuPositionBound = false;

function syncMegaMenuTopOffset() {
  const header = document.querySelector('#header-component');
  if (!(header instanceof HTMLElement)) return;

  const headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  document.body.style.setProperty('--megamenu-top-offset', `${headerBottom}px`);
}

function bindMegaMenuTopOffsetSync() {
  if (isMegaMenuPositionBound) return;
  isMegaMenuPositionBound = true;

  let rafId = null;

  const scheduleSync = () => {
    if (rafId !== null) return;

    rafId = requestAnimationFrame(() => {
      rafId = null;
      syncMegaMenuTopOffset();
    });
  };

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync, { passive: true });

  const header = document.querySelector('#header-component');
  if (header instanceof HTMLElement && 'ResizeObserver' in window) {
    const observer = new ResizeObserver(scheduleSync);
    observer.observe(header);
  }

  scheduleSync();
}

function setupMegaMenuHover() {
  bindMegaMenuTopOffsetSync();

  if (isMegaMenuHoverBound) return;

  const menuList = document.querySelector('.header-menu .menu-list');
  if (!menuList) return;

  const menuItems = Array.from(menuList.querySelectorAll('.menu-list__list-item[id]'));
  const megaMenus = Array.from(document.querySelectorAll('.megamenu-item[data-megamenu]'));

  if (!menuItems.length || !megaMenus.length) return;

  isMegaMenuHoverBound = true;

  const megaMenuMap = new Map();
  megaMenus.forEach((menu) => {
    const key = menu.dataset.megamenu;
    if (!key) return;
    megaMenuMap.set(key, menu);
  });

  /** @type {string | null} */
  let activeKey = null;

  const hideAll = () => {
    megaMenus.forEach((menu) => {
      menu.classList.remove('is-active');
      menu.hidden = true;
    });
    activeKey = null;
  };

  const showByKey = (key) => {
    const targetMenu = megaMenuMap.get(key);
    if (!targetMenu) {
      hideAll();
      return;
    }

    megaMenus.forEach((menu) => {
      const isTarget = menu === targetMenu;
      menu.classList.toggle('is-active', isTarget);
      menu.hidden = !isTarget;
    });

    activeKey = key;
  };

  const isPointerOverMenuOrMegaMenu = () => {
    const hoveredMenuItem = menuList.querySelector('.menu-list__list-item:hover');
    const hoveredMegaMenu = document.querySelector('.megamenu-item:hover');
    return Boolean(hoveredMenuItem || hoveredMegaMenu);
  };

  menuList.addEventListener('pointerenter', (event) => {
    const item = event.target instanceof Element ? event.target.closest('.menu-list__list-item[id]') : null;
    if (!item) return;
    showByKey(item.id);
  }, true);

  menuList.addEventListener('focusin', (event) => {
    const item = event.target instanceof Element ? event.target.closest('.menu-list__list-item[id]') : null;
    if (!item) return;
    showByKey(item.id);
  });

  megaMenus.forEach((menu) => {
    menu.addEventListener('pointerleave', () => {
      requestAnimationFrame(() => {
        if (!isPointerOverMenuOrMegaMenu()) {
          hideAll();
        }
      });
    });
  });

  menuList.addEventListener('pointerleave', () => {
    requestAnimationFrame(() => {
      if (!isPointerOverMenuOrMegaMenu()) {
        hideAll();
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeKey) {
      hideAll();
    }
  });

  hideAll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupMegaMenuHover);
} else {
  setupMegaMenuHover();
}

document.addEventListener('shopify:section:load', setupMegaMenuHover);
